import { render } from "./ban-modal.vue?vue&type=template&id=f64ae7be"
import script from "./ban-modal.vue?vue&type=script&lang=js"
export * from "./ban-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__